import { gql } from 'apollo-angular';

export const PRODUCT_LINE_PRODUCT_FRAGMENT = gql`
  fragment ProductLineProductFragment on ProductLine {
    snkProductName
    snkProductText
  }
`;
